import React, { useState } from 'react';
import { connect } from 'react-redux';
import { getCMSObject, SweepstakeDetails, DrawingGroupTable } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import WinnerLinkWrapper from '../Components/WinnerLinkWrapper';
import ProgressiveJackpot from '../Components/ProgressiveJackpot/ProgressiveJackpot';

const SecondChancePromotion = ({ user, config, sweep, cmsSourceFirebase, actions, match, loading }) => {
    const [promotionName, setPromotionName] = useState('Promotion Details');

    const telescriptSweepstakeDetails = getCMSObject('data.components.teleScripts.sweepstakeDetails.jsonBlock');
    const telescriptDrawingGroupTable = getCMSObject('data.components.teleScripts.drawingGroupTable.jsonBlock');

    const DrawingGroupTableWrapper = ({ drawingGroup, loggedIn }) => {
        return <DrawingGroupTable drawingGroup={drawingGroup} loggedIn={loggedIn} telescript={telescriptDrawingGroupTable} WinnerLink={WinnerLinkWrapper} />;
    };

    return (
        <Layout
            {...{
                user,
                sweep,
                config,
                cmsSourceFirebase,
                actions,
                match,
                configReplacements: [
                    {
                        find: '{{PROMOTION_NAME}}',
                        replace: promotionName ?? '',
                    },
                ],
            }}>
            <SweepstakeDetails
                {...{ user, sweep: sweep.sweepDetails, actions, loading }}
                telescript={telescriptSweepstakeDetails}
                DrawingGroupTable={DrawingGroupTableWrapper}
                ProgressiveJackpot={ProgressiveJackpot}
                setPageTitle={setPromotionName}
            />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SecondChancePromotion);
